import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from '@mui/material';

interface CreateModalProps {
  children: React.ReactNode;
  open: boolean;
  title: string;
  handleClose: () => void;
  info?: string;
}

const CreateModal = ({ children, open, title, handleClose, info }: CreateModalProps) => {
  return (
    <Dialog
      open={open}
      fullWidth
      onClose={handleClose}
      aria-labelledby="create-service-dialog"
      aria-describedby="create-service-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
        },
      }}
    >
      <DialogTitle
        id="create-service-dialog"
        sx={{ fontSize: '18px', display: 'flex', alignItems: 'center' }}
        color="primary"
      >
        {title}
        {info && (
          <Box
            component="a"
            href={info}
            target="_blank"
            rel="noreferrer"
            title={info}
            sx={{ ml: 2, display: 'flex', alignItems: 'center' }}
          >
            <InfoOutlinedIcon color="secondary" fontSize="small" />
          </Box>
        )}
      </DialogTitle>
      <DialogContent
        sx={{
          paddingTop: '8px !important',
          width: '100%',
        }}
      >
        {children}
      </DialogContent>
      <DialogActions>
        <IconButton
          sx={{
            position: 'absolute',
            top: '8px',
            right: '8px',
          }}
          onClick={handleClose}
        >
          <HighlightOffOutlinedIcon fontSize="small" />
        </IconButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreateModal;
